/**
 * Identificador de rota: minúsculas, números e _, derivado do rótulo que o
 * usuário digita. É o valor que vai para o `branch` dos passos e para as
 * origens de uma junção, e o backend recusa qualquer coisa fora do padrão
 * `^[a-z0-9_]+$`.
 *
 * Mora fora do editor de caminhos porque o reducer também precisa dele — é ele
 * que deriva o identificador da junção a partir do rótulo, e sem regra única a
 * rota gravada e a rota referenciada divergiriam.
 */
export const slugifyRouteName = (text) =>
    String(text ?? "")
        .toLowerCase()
        .normalize("NFD")
        // Acentos separados pelo NFD (combining marks), para "Não" virar "nao".
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9_]+/g, "_")
        .replace(/^_+|_+$/g, "");

/**
 * Identificadores que se repetem numa lista de caminhos.
 *
 * O vínculo de um passo com o caminho dele é só o identificador, gravado no
 * `branch`. Dois caminhos com o mesmo identificador são, por construção,
 * indistinguíveis: não há como dizer a qual deles um passo pertence. Rótulos
 * diferentes podem colidir depois do slug ("Não aprovado" e "Nao-aprovado"
 * viram `nao_aprovado`), então a checagem é sobre o `name`, não sobre o rótulo.
 */
export const findDuplicateRouteNames = (routes) => {
    const seen = new Set();
    const duplicates = new Set();

    (Array.isArray(routes) ? routes : []).forEach((route) => {
        const name = route?.name;
        if (!name) return;
        if (seen.has(name)) {
            duplicates.add(name);
        } else {
            seen.add(name);
        }
    });

    return duplicates;
};
